<script setup lang="ts">
import { storeToRefs } from 'pinia';
import type { CatalogInApp } from '~/interfaces/app';
import { useGlobalStore } from '~/stores/global';

const globalStore = useGlobalStore();
const levelCatalog = ref<number>(1);

const { catalog, isInitCatalog } = storeToRefs(globalStore);

const selectedBase = ref<CatalogInApp>(
  catalog.value?.length ? catalog.value[0] : { title: '', url: '/' }
);

const selectedSub = ref<CatalogInApp>(
  catalog.value?.length && catalog.value[0].children
    ? catalog.value[0].children[0]
    : { title: '', url: '/' }
);

function setBase(value: CatalogInApp) {
  selectedBase.value = value;
  levelCatalog.value = 2;
}

function setSub(value: CatalogInApp) {
  selectedSub.value = value;
  levelCatalog.value = 3;
}

function setLast() {
  setMenu(false);
}

function setMenu(v: boolean) {
  globalStore.setMenuOpen(v);
}

function levelChange() {
  if (levelCatalog.value > 1) {
    levelCatalog.value--;
  }
}

const emit = defineEmits(['search']);
</script>
<template>
  <nav class="nav">
    <div class="catalog-wrapper" :class="[`mobile-slider-${levelCatalog}`]">
      <MenuBase
        :catalog="catalog"
        :selected-base="selectedBase"
        @click-categories="setBase"
        @search="emit('search')"
      />
      <template v-if="isInitCatalog">
        <div class="sub-menu-wrapper">
          <MenuSub
            :level-catalog="Number(levelCatalog)"
            :catalog="catalog"
            :selected-base="selectedBase"
            @level-change="levelChange"
            @click-categories="setSub"
            @search="emit('search')"
          />
        </div>
        <div class="last-menu-wrapper">
          <MenuLast
            :level-catalog="Number(levelCatalog)"
            :selected-sub="selectedSub"
            @level-change="levelChange"
            @click-categories="setLast"
            @search="emit('search')"
          />
        </div>
      </template>
    </div>
  </nav>
</template>

<style lang="scss" scoped>
.catalog-wrapper {
  display: grid;
  grid-template-columns: 1fr 1fr 1fr;
  transition: transform 0.3s ease-in-out;

  @include xl-block {
    grid-template-columns: max-content 1fr;
    box-shadow: 0 500px 0 510px #fff;
    max-width: 1280px;
    width: 100%;
    margin: auto;
  }
  @include xxl-block {
    max-width: 1600px;
    //border-top: 1px solid #e7e7e7;
  }

  .last-menu-wrapper {
    @include xl-block {
      display: none;
    }
  }

  &.mobile-slider-2 {
    transform: translateX(-100vw);
    @include xl-block {
      transform: none;
    }
  }

  &.mobile-slider-3 {
    transform: translateX(-200vw);
    @include xl-block {
      transform: none;
    }
  }

  // display: none;
}
</style>
